import 'whatwg-fetch';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { API_ROOT } from 'signoxe/constants/config';
import { CONTENT_FEEDS_RESOURCE, DEVICE_GROUPS_RESOURCE, DEVICES_RESOURCE } from "signoxe/api/resources";
import { getAuthTokenHeader } from "signoxe/actions/remote";
import { confirmationRequest, downloadReport, toggleDeviceId, updateDeviceGroup, deleteDeviceGroup } from "signoxe/actions";
import {
  ContentFeedView,
  PriorityMessageView,
  ScheduleSummaryView,
} from 'signoxe/components';
import UngropedDeviceView from '../UngropedDeviceView';
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown';
import { Box } from 'signoxe/components/layout';
import { HoverView, Icon, Switch } from 'signoxe/components/widgets';
import './styles.scss';
import { connect } from "react-redux";
import { getProfile, getFilteredDevicesWrapers } from "signoxe/selectors";
import { DeviceGroupSelect } from "..";
import { Link } from "react-router-dom";
import * as _ from "lodash";
import SelectSearch from '../widgets/SelectSearch';
import { ScreenResolutionSelectWidget } from '../widgets/ScreenResolutionSelectWidget';

class DeviceUngroupedView extends Component {
  constructor(props) {
    super(props);

    let syncPeriodicityValue = 0;
    let syncPeriodicityMultiplier = 60;
    const deviceGroup = this.props.deviceGroup;
    const syncPeriodSeconds = (deviceGroup.feed && deviceGroup.feed.group_sync_period_seconds) || 0;
    if (syncPeriodSeconds > 0) {
      let remainder = syncPeriodSeconds % 3600;
      if (remainder > 0) {
        syncPeriodicityValue = Math.floor(syncPeriodSeconds / 60);
        syncPeriodicityMultiplier = 60;
      } else {
        syncPeriodicityValue = Math.floor(syncPeriodSeconds / 3600);
        syncPeriodicityMultiplier = 3600;
      }
    }

    this.state = {
      showPriorityMessage: false,
      syncPeriodicityValue,
      syncPeriodicityMultiplier,
      showDevices: true,
      devices: this.props.deviceGroup.devices,
      searchInput: '',
      filteredResults: [],
      showSearchBox: false,
      pageNumber: 1,
      rowNumber: 5
    };
  }

  searchItems = (searchValue) => {
    this.setState({ searchInput: searchValue })

    if (this.state.searchInput !== '') {
      const filteredData = this.state.devices.filter((item) => {
        return Object.values(item.name).join('').toLowerCase().includes(this.state.searchInput.toLowerCase())
      })
      this.setState({ filteredResults: filteredData })
    }
    else {
      this.setState({ filteredResults: this.state.devices })
    }
  }

  static propTypes = {
    screenshotsEnabled: PropTypes.bool,
    deviceReportEnabled: PropTypes.bool,
    rebootEnabled: PropTypes.bool,
    RestartAppEnabled: PropTypes.bool,
    ClearUnusedMediaEnabled: PropTypes.bool,
    offlineEnabled: PropTypes.bool,
    delayDownloadEnabled: PropTypes.bool,
    smartBoardEnabled: PropTypes.bool,
    fetchAll: PropTypes.func.isRequired,
    downloadReport: PropTypes.func.isRequired,
    groupList: PropTypes.array.isRequired,
    dropdownGroups: PropTypes.array.isRequired,
    onDeviceChange: PropTypes.func.isRequired,
    onGroupFeedChange: PropTypes.func.isRequired,
    onDeviceGroupDelete: PropTypes.func.isRequired,
    onDeviceGroupChange: PropTypes.func.isRequired,
    onClickSchedule: PropTypes.func.isRequired,
    onPriorityMessageChange: PropTypes.func.isRequired,
    onPriorityMessageDeactivate: PropTypes.func.isRequired,
    onPriorityMessageActivate: PropTypes.func.isRequired,
    searchString: PropTypes.string.isRequired,
    activePlaylist: PropTypes.string.isRequired,
    deviceTags: PropTypes.object,
    groups: PropTypes.array.isRequired,
  };

  handleToggleShowPriorityMessage = () =>
    this.setState({ showPriorityMessage: !this.state.showPriorityMessage })

  configComponent() {
    const { deviceGroup, onGroupFeedChange, onDeviceGroupChange, profile, handleUserReport } = this.props;

    return (deviceGroup.schedule.present ||
      (profile && profile.features && profile.features.multichannel ?
        <React.Fragment>
          <Box direction="row"
            alignItems="center"
            className="device-group-config" wrap>
            <ContentFeedView onDeviceGroupChange={onDeviceGroupChange} profile={profile} deviceGroup={deviceGroup} feed={deviceGroup.feed} onChange={onGroupFeedChange} />
          </Box>
          {deviceGroup.feed_chain.filter(feed => feed.id !== deviceGroup.feed.id).map(feed =>
            <Box
              direction="row" alignItems="center" className="device-group-config" wrap
            >
              <ContentFeedView
                 profile={profile} onDeviceGroupChange={onDeviceGroupChange}
                deviceGroup={deviceGroup} feed={feed} onChange={onGroupFeedChange} hideDurations={true} hideOrientationSelection={true}
                hideOverlayTickers={true}
              /> 
              <Icon name="trash-o" size="1.5rem" title="Remove Feed" onClick={() => this.deleteFeed(feed)} />
            </Box>)}
          <Box direction="row" alignItems="center" className="device-group-config" wrap>
            <Switch checked={deviceGroup.display_date_time}
              formId={`show-time-${deviceGroup.id}`}
              label="Show Time"
              size="large"
              onChange={({ currentTarget }) =>
                onDeviceGroupChange(deviceGroup.id, { display_date_time: currentTarget.checked })
            } />
          </Box>
        </React.Fragment> :
        <Box direction="row"
          alignItems="center"
          className="device-group-config" wrap>
          <ContentFeedView
          profile={profile} onDeviceGroupChange={onDeviceGroupChange}
          deviceGroup={deviceGroup} feed={deviceGroup.feed} onChange={onGroupFeedChange} />
          <Switch checked={deviceGroup.display_date_time}
            formId={`show-time-${deviceGroup.id}`}
            label="Show Time"
            size="large"
            onChange={({ currentTarget }) =>
              onDeviceGroupChange(deviceGroup.id, { display_date_time: currentTarget.checked })
            }
          />
        </Box>
      )
    );
  }

  showText(text) {
    return <span className='show-text'>{text}</span>
  }

  optionComponent(reboot, restart_app_enabled, ClearUnusedMediaEnabled, device) {
    const {
      deviceGroup, onClickSchedule, onDeviceGroupChange, onDeviceGroupDelete, onGroupFeedChange,
      smartBoardEnabled, profile, toggleDeviceId, searchString,  activePlaylist, onDeviceChange,
      deviceTags, 
    } = this.props;

    const visible = this.state.showDevices;
    const { showSearchBox } = this.state
    
    const offlineOnly = localStorage.getItem('offlineOnly')

    // console.log(this.props.groupss)

    const handleChangeTag = (option) => onDeviceChange({ id: device.id, tags: option }) 
    
    // DEVICE TAG OPTIONS
    let default_deviceTags = []
    if(device && device.tags){
      default_deviceTags = device.tags
    }
    
    var deviceTags_Options = []
    deviceTags?
      deviceTags.map((option) => {
        deviceTags_Options.push({label:option.name, value:option.id})
      })
    : null
    
    return (
      <>
        {
          device && offlineOnly === 'false' ?
          <div>
          <Dropdown>

            <DropdownTrigger>
              <span className='device-action-icon'>
                <Icon title="Group options"
                  name="sliders"
                  size="1.2rem"
                />
              </span>
            </DropdownTrigger>
            <DropdownContent className="user-menu options-menu card depth-1">

              {smartBoardEnabled &&
                <li>
                  <Icon name="bullhorn" size="1.5rem" title="Priority Announcement"
                    onClick={this.handleToggleShowPriorityMessage}
                    color={(deviceGroup.priority_message && deviceGroup.priority_message.activated_on)
                      ? 'red'
                      : 'black'} /> 
                </li>}

              <li className="hide-for-large">
                <span >Screenshots</span>
                <Link to={`devices/${device.id}`}>
                  <Icon title="Screenshots" name="picture-o" />
                </Link>
              </li>

              <li onClick={() => onClickSchedule(deviceGroup)}> 
                <HoverView hoverView={
                  deviceGroup.schedule.present &&
                  <ScheduleSummaryView schedule={deviceGroup.schedule} specials={deviceGroup.specials} />
                }>
                  <span>Schedule</span>
                  <Icon title="Schedule"
                    name="calendar-o"
                    size="1rem"
                    color={deviceGroup.schedule.present ? 'green' : undefined}
                    className={classNames({ scheduled: deviceGroup.schedule.present })}
                  />
                </HoverView>
              </li>

              <li>
                  {reboot}
              </li>

              <li>
                  {restart_app_enabled}
              </li>

              <li>
                  {ClearUnusedMediaEnabled}
              </li>

              {this.props.offlineEnabled && (
                <li className='show-for-small-only'>
                  <div
                  style={{ margin: "0px" }}
                    onClick={() => onDeviceChange({ id: device.id, device_status: device.device_status=='online'? 'offline' : 'online' })}
                    style={{display:'flex', flexDirection:'row'}}
                  >
                    <span style={{marginRight:'5px'}}>offline </span> <Switch checked={device.device_status != 'online'} size="tiny" />
                  </div>
                </li>
              )}

              {
                profile != undefined && profile.profile.package.device_tags?
                  <li>
                    <strong
                      style={{ marginRight: "6px" }}
                    >
                      Tag
                    </strong>
                    <SelectSearch 
                      placeHolder={default_deviceTags}  
                      options={deviceTags_Options} 
                      style={{width:`8rem`, backgroundColor:'white'}}
                      onSelect={ (values)=>  handleChangeTag(values) }
                      name={'Select tag'}
                      id={'SelectTag'}
                      multiple={true}
                    />
                  </li>
                : null
              }

              {
                profile != undefined && profile.profile.package.device_screen_resolution?
                  <li>
                    <strong
                      style={{ marginRight: "6px" }}
                    >
                      Screen
                    </strong>
                    <ScreenResolutionSelectWidget 
                      device={device}
                      onDeviceChange={onDeviceChange}
                    />
                  </li>
                : null
              }

              <li className="device-group-select show-for-small-only">
                <strong
                  style={{ marginRight: "6px" }}
                >
                  Group
                </strong>
                <DeviceGroupSelect
                  groups={this.props.dropdownGroups}
                  selected={device.group}
                  setUngroup={false}
                  onChange={async (grpId) => {
                    await onDeviceChange({ id: device.id, group: grpId })
                    await deleteDeviceGroup(deviceGroup.id)
                  }}
                />
              </li>

              <li onClick={() => onDeviceGroupDelete(deviceGroup)}>
                <span style={{ color: '#cc4b37' }}>Unassign</span> <Icon title="Delete"
                  name="trash-o"
                  size="1rem"
                  color="#cc4b37"
                />
              </li>
            </DropdownContent>
          </Dropdown>
          </div>
          :
          <Fragment>
            
          </Fragment>
        }
      </>
    );
  }

  priorityMessageComponent() {
    const {
      deviceGroup,
      onPriorityMessageActivate, onPriorityMessageChange, onPriorityMessageDeactivate,
      devices,
    } = this.props;
    const { priority_message } = deviceGroup;
    const activated = priority_message && priority_message.activated_on;

    return ((this.state.showPriorityMessage || activated) &&
      <PriorityMessageView priorityMessage={priority_message}
        onChange={(newMsg) => onPriorityMessageChange(deviceGroup.id, newMsg)}
        onDeactivate={() => onPriorityMessageDeactivate(deviceGroup.id)}
        onActivate={() => onPriorityMessageActivate(deviceGroup.id)} />
    );
  }

  addFeed() {
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: getAuthTokenHeader(),
      },
      credentials: 'same-origin',
    };
    return fetch(`${API_ROOT}${DEVICE_GROUPS_RESOURCE}/${this.props.deviceGroup.id}/feeds/`, requestOptions).then(
      response => response.json()
    ).then(feed => this.props.fetchDeviceGroups(this.props.deviceGroup.id));
  }

  deleteFeed(feed) {
    this.props.confirmationRequest(
      'Deleting Content Feed',
      `Deleting the content feed "${feed.title}" is permanent and cannot be undone.`,
      'DELETE',
      CONTENT_FEEDS_RESOURCE,
      feed.id,
    )
  }

  rebootDevice(device) {
    this.props.confirmationRequest(
      'Rebooting Device',
      `Rebooting Device "${device.name}", this action can't be undone.`,
      'REBOOT',
      DEVICES_RESOURCE,
      device.id
    )
  }

  RestartApp(device) {
    this.props.confirmationRequest(
      'Restarting Application',
      `Restarting Application on Device "${device.name}", this action can't be undone.`,
      'RESTART_APP',
      DEVICES_RESOURCE,
      device.id
    )
  }

  ClearUnusedMedia(device) {
    this.props.confirmationRequest(
      'Clearing Unused Media',
      `Clearing Unused Media on Device "${device.name}", this action can't be undone.`,
      'CLEAR_UNUSED_MEDIA',
      DEVICES_RESOURCE,
      device.id
    )
  }



  render() {
    const { deviceGroup, groupList, dropdownGroups, onDeviceChange, screenshotsEnabled, downloadReport,
      deviceReportEnabled, smartBoardEnabled, offlineEnabled, delayDownloadEnabled, rebootEnabled, RestartAppEnabled, ClearUnusedMediaEnabled,
      searchString, devices, toggleDeviceId, activePlaylist } = this.props;

    const { devices, searchInput, visible, filteredResults, showSearchBox, pageNumber, rowNumber } = this.state;
    // const iteratees = (device) => device.name == "vote";

    //Will need to be refactored

    //devices
    const pages = Math.ceil(deviceGroup.devices.length/rowNumber)
    const rowNumbers = () => {
      const rows = Math.ceil(deviceGroup.devices.length/5) * 5
      let options = []
      for(let i = 5; i <= rows; i += 5){
        options.push(
        <option value={i}>
          {i}
        </option>)
      }
      return(
        options
      )
    }

    console.log(deviceGroup)

    const handleRows = (event) => {
      this.setState({rowNumber: event.target.value})
      this.setState({ pageNumber: 1 })
    }

    let devices = []
    if(pageNumber == 1){
      devices = deviceGroup.devices.slice(0, rowNumber)
    }else{
      devices = deviceGroup.devices.slice(rowNumber * (pageNumber - 1), rowNumber * (pageNumber))
    }

    //filtered devices
    
    const filteredPages = Math.ceil(filteredResults.length/rowNumber)
    const filteredRowNumbers = () => {
      const rows = Math.ceil(filteredResults.length/5) * 5
      let options = []
      for(let i = 5; i <= rows; i += 5){
        options.push(
        <option value={i}>
          {i}
        </option>)
      }
      return(
        options
      )
    }

    console.log("Fpages filteredResults", devices)

    let filteredDevices = []
    if(pageNumber == 1){
      filteredDevices = filteredResults.slice(0, rowNumber)
    }else{
      filteredDevices = filteredResults.slice(rowNumber * (pageNumber - 1), rowNumber * (pageNumber))
    }
    
    console.log("filteredDevices", filteredDevices)
    const offlineOnly = localStorage.getItem('offlineOnly')
    return (
      <>
        {smartBoardEnabled && this.priorityMessageComponent()}
        {/*this.configComponent()*/}

        <tbody className={this.state.showDevices ? 'device-table' : 'hide-device-table'}>

          {searchInput.length > 1 ? (
            filteredDevices.map((device, index) =>{ 
            if(!(index > rowNumber - 1)){
            return(
              <UngropedDeviceView key={device.device_id}
                deviceReportEnabled={deviceReportEnabled}
                rebootEnabled={rebootEnabled}
                RestartAppEnabled={RestartAppEnabled}
                ClearUnusedMediaEnabled={ClearUnusedMediaEnabled}
                offlineEnabled={offlineEnabled}
                delayDownloadEnabled={delayDownloadEnabled}
                screenshotsEnabled={screenshotsEnabled}
                device={device}
                reportCall={downloadReport}
                onChange={onDeviceChange}
                groupList={groupList}
                deviceGroup={deviceGroup}
                dropdownGroups={dropdownGroups}
                rebootDevice={this.rebootDevice.bind(this)}
                RestartApp={this.RestartApp.bind(this)}
                ClearUnusedMedia={this.ClearUnusedMedia.bind(this)}
                optionComponent={this.optionComponent.bind(this)}
                toggleDeviceId={toggleDeviceId}
                activePlaylist={activePlaylist}
             />

            )}})
          ) : ( this.props.deviceGroup && this.props.deviceGroup.devices.map((device, index) => {
            if(!(index > rowNumber - 1)){
            return (
              <UngropedDeviceView key={device.device_id}
              deviceReportEnabled={deviceReportEnabled}
              rebootEnabled={rebootEnabled}
              RestartAppEnabled={RestartAppEnabled}
              ClearUnusedMediaEnabled={ClearUnusedMediaEnabled}
              offlineEnabled={offlineEnabled}
              delayDownloadEnabled={delayDownloadEnabled}
              screenshotsEnabled={screenshotsEnabled}
              device={device}
              reportCall={downloadReport}
              onChange={onDeviceChange}
              groupList={groupList}
              deviceGroup={deviceGroup}
              dropdownGroups={dropdownGroups}
              rebootDevice={this.rebootDevice.bind(this)}
              RestartApp={this.RestartApp.bind(this)}
              ClearUnusedMedia={this.ClearUnusedMedia.bind(this)}
              optionComponent={this.optionComponent.bind(this)}
              toggleDeviceId={toggleDeviceId}
              activePlaylist={activePlaylist}
              />
            )}}))}
        </tbody>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    profile: getProfile(state),
    groupss: getFilteredDevicesWrapers(state, ''),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    confirmationRequest: (title, message, operation, resourceType, id) => dispatch(confirmationRequest(
      title, message, operation, resourceType, id
    )),
    downloadReport: (deviceID) => dispatch(downloadReport(deviceID)),
    toggleDeviceId: (id) => dispatch(toggleDeviceId(id)),
    updateDeviceGroup: (id, data) => dispatch(updateDeviceGroup(id, data))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUngroupedView);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DeviceUngroupedView/index.js